export default "__VITE_ASSET__BkpvEJIl__"